import { Component, OnInit, ViewChild } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { Campaign } from '../campaign/campaign/campaign';
import { CampaignsData } from '../campaign/campaigns.data';


@Component({
  selector: 'screen-page',
  templateUrl: 'screen.component.html',
  styleUrls: ['./screen-page.scss'],
})

export class ScreenComponent implements OnInit {
  
  constructor(private campaignsData: CampaignsData) {

  }


  @ViewChild('boxesContainer') boxesContainer: HTMLDivElement;
  campaign: Campaign;
  boxWidth = 160;
  boxHeight = 160;
  fontsize = 18;
  marginTopBox = 30;
  marginRight=-27;
 
  setSizes() {
    if (this.campaign && this.campaign.duplicationCampaignAttacheds) { 

      if (this.campaign.duplicationCampaignAttacheds.length > 200) {
        this.boxHeight = 70;
        this.boxWidth = 70;
        this.fontsize = 10;
        this.marginTopBox = 3;
        this.marginRight=-12;
     } else if (this.campaign.duplicationCampaignAttacheds.length > 80) {
      this.boxHeight = 90;
      this.boxWidth = 90;
      this.fontsize = 9;
      this.marginTopBox = 3;
      this.marginRight=-17;
   } else if (this.campaign.duplicationCampaignAttacheds.length > 50) {
        this.boxWidth = 95;
        this.boxHeight = 95;
        this.fontsize = 13;
        this.marginTopBox = 8;
        this.marginRight=-15;
     } else {
        this.boxWidth = 150;
        this.boxHeight = 150;
        this.fontsize = 18;
        this.marginTopBox = 25;
        this.marginRight=-24;
      }
    } 
  }



  loadCampaign(): void {


    this.campaignsData.get(1)
      .subscribe((c: any) => {
        this.campaign = c;
        this.setSizes();
      });
  }

  private updateSubscription: Subscription;

  ngOnInit(): void {
    this.loadCampaign();
    this.updateSubscription = interval(3000).subscribe(
      (val) => {
        this.loadCampaign();
      });
  }
}

/**  Copyright 2019 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
